var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"#EBA920","key":0}),React.createElement("path",{"d":"M11.1 8.57H9.28V15.36H11.1V8.57ZM9 6.162C9 6.82 9.532 7.324 10.19 7.324C10.848 7.324 11.38 6.82 11.38 6.162C11.38 5.504 10.848 5 10.19 5C9.532 5 9 5.504 9 6.162Z","fill":"#FFFBE7","key":1})]);
}

InfoIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
